const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.DIET)

export const apiDiet = {
	fetchDiets: async (search: string | undefined, status?: EDietStatus[], page: number = 1, perPage: number = 25) => {
		const { data, meta } = await apiCommon<IDiet[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery({ page, perPage }, { name: search, status }),
		})

		return { data: data.map(d => Diet(d)), meta }
	},
	fetchDietSingle: async (dietID: number): Promise<IApiResponseModel<IDietModel>> => {
		const { data } = await apiCommon<IDiet>(`${groupPrefix}/${dietID}`, {
			method: 'GET',
		})
		return { data: Diet(data) }
	},
	createDiet: async (payload: IDietCreatePayload) => {
		const { data } = await apiCommon<IDiet>(`${groupPrefix}`, {
			method: 'POST',
			body: payload,
		})

		return Diet(data)
	},
	updateDiet: async (payload: IDietUpdatePayload) => {
		const { data } = await apiCommon<IDiet>(`${groupPrefix}/${payload.id}`, {
			method: 'PUT',
			body: payload,
		})

		return Diet(data)
	},

	updateDietOrder: async (diets: { id: number; order: number }[]) => {
		const { data } = await apiCommon<IDiet>(`${groupPrefix}/update-order`, {
			method: 'POST',
			body: { diets },
		})
		return data
	},

	fetchDietCaloriesList: async (): Promise<IDietCalories[]> => {
		const { data } = await apiCommon<IDietCalories[]>(`${groupPrefix}/kcals`, { method: 'GET' })

		return data
	},

	archiveDiet: async (dietID: number) => {
		const { data } = await apiCommon<string>(`${groupPrefix}/${dietID}`, {
			method: 'DELETE',
		})
		return data
	},

	reactivateDiet: async (dietID: number) => {
		const { data } = await apiCommon<IDiet>(`${groupPrefix}/${dietID}/restore`, {
			method: 'POST',
		})
		return data
	},

	duplicateDiet: async (dietID: number) => {
		const { data } = await apiCommon<IDiet>(`${groupPrefix}/${dietID}/duplicate`, {
			method: 'POST',
		})
		return Diet(data)
	},

	apiMap: {
		diets: createApiRoute(ApiModule.DIETARY, ApiDataModel.DIET),
		menus: createApiRoute(ApiModule.DIETARY, ApiDataModel.DIET),
		meals: createApiRoute(ApiModule.DIETARY, ApiDataModel.MEAL),
		mealpreps: createApiRoute(ApiModule.DIETARY, ApiDataModel.MEAL),
		semiProducts: createApiRoute(ApiModule.DIETARY, ApiDataModel.SEMI_PRODUCT),
		allergens: createApiRoute(ApiModule.DIETARY, ApiDataModel.ALLERGENS),
		menuDiet: createApiRoute(ApiModule.DIETARY, ApiDataModel.DIET_DAYS),
	},

	apiModelMap: {
		diets: Diet,
		menus: Diet,
		meals: DietMeal,
		mealpreps: DietMeal,
		semiProducts: DietSemiProduct,
		allergens: DietAllergen,
		menuDiet: DietMenu,
	},
	fetchDietModelEditableStatus: async (model: IDietStoreModelKey, modelID: number) => {
		const response = await apiCommon<any>(`${apiDiet.apiMap[model]}/${modelID}/edit`, {
			method: 'POST',
		})
		return { isLocked: response.is_locked, data: response.data ? apiDiet.apiModelMap[model](response.data) : null }
	},

	unlockDietModelEditableStatus: async (model: IDietStoreModelKey, modelID: number) => {
		const { data } = await apiCommon<boolean>(`${apiDiet.apiMap[model]}/${modelID}/unlock`, {
			method: 'POST',
		})
		return data
	},
}
